import FadeInBox from './FadeInBox';

export default FadeInBox;
